const types = {
    BREAD_BOTTOM: 'bread-bottom',
    BREAD_TOP: 'bread-top',
    MEAT: 'meat',
    CHEESE: 'cheese',
    SALAD: 'salad',
    BACON: 'bacon'
};

export default types;